import type { SanityPageBuilderSection, SanityPageBuilderTextMedia13BSection } from "@ouster/shared";
import { up } from "~/features/app/screens";
import { TextMediaBlock1_3_BView } from "~/features/blocks/inventory/text-media1_3_B";
import { useMediaQuery } from "~/features/ui/use-media-query";
import { hasRenderableSanityMedia, SanityMediaFigure } from "./media-figure";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderTextMedia13BSection;
  };
};
export function SanityTextMedia13BSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const hasMedia = hasRenderableSanityMedia(sectionContent.media);
  // Below lg the media column has no intrinsic height, so a fixed 3/2 ratio keeps it visible
  // Fit and ratio switch at the large-screen breakpoint.
  const isLg = useMediaQuery(up("lg"));
  return <TextMediaBlock1_3_BView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} media={hasMedia ? <SanityMediaFigure fit={isLg ? "cover" : "fill"} media={sectionContent.media} ratio={isLg ? undefined : "3/2"} sizes="lg:33vw" /> : undefined} mediaPosition={sectionContent.mediaPosition} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}